"use client";

import Link from "next/link";
import {MouseEvent, ReactNode} from "react";
import {scrollToFirstSection} from "@/app/utils/scroll-to-section";

interface SmoothScrollLinkProps {
    href: string;
    className?: string;
    children: ReactNode;
}

export default function SmoothScrollLink({href, className, children}: SmoothScrollLinkProps) {
    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        if (!href.startsWith("#")) return;
        const id = href.slice(1);
        if (!document.getElementById(id)) return;
        event.preventDefault();
        scrollToFirstSection([id]);
        if (window.location.hash !== href) {
            history.pushState(null, "", href);
        }
    };

    return (
        <Link href={href} className={className} onClick={handleClick}>
            {children}
        </Link>
    );
}
